var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5202 2.18361C21.394 1.76155 21.1479 1.37678 20.8063 1.0676C20.4647 0.75842 20.0396 0.535625 19.5733 0.4214C17.8661 0 10.9954 0 10.9954 0C10.9954 0 4.12429 0.0127555 2.41713 0.434156C1.95081 0.548388 1.52569 0.771194 1.18411 1.08039C0.842521 1.38958 0.596388 1.77437 0.470218 2.19644C-0.0461574 4.94184 -0.246469 9.1252 0.484397 11.7608C0.61058 12.1828 0.856719 12.5676 1.1983 12.8768C1.53989 13.186 1.965 13.4088 2.43131 13.523C4.13847 13.9444 11.0094 13.9444 11.0094 13.9444C11.0094 13.9444 17.8802 13.9444 19.5873 13.523C20.0536 13.4088 20.4787 13.186 20.8203 12.8768C21.1619 12.5676 21.4081 12.1828 21.5343 11.7608C22.0789 9.01149 22.2468 4.8307 21.5202 2.18361Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80826 9.96022L14.5081 6.97215L8.80826 3.98409V9.96022Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 14,
    fill: "white",
    transform: "translate(0.00634766)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.22dd971e6742680fd10ce3f1fd15f132.svg";
export { ForwardRef as ReactComponent };